import { getAuthToken } from './api';
import { getFreshAuthToken } from './authRefresh';
/**
 * `action` and `headers` for an antd `Upload` that sends a fresh access token
 * with every file, however long ago the component rendered.
 */
export function authenticatedUploadProps(action) {
    return {
        // rc-upload awaits `action` right before each request; a rejection would silently drop the upload.
        action: async () => {
            await getFreshAuthToken().catch(() => null);
            return action;
        },
        // rc-upload reads each header after awaiting `action`, so the getter sees the renewed token.
        headers: {
            get Authorization() {
                const token = getAuthToken();
                return token ? `Token ${token}` : '';
            },
        },
    };
}
